// Replace characters within the slug, using the Slug character look up from Contentful
const replaceSlug = (slug, lookUp = {}, exceptions = []) => {
  if (exceptions.length !== 0 && exceptions.includes(slug)) {
    return slug;
  }

  if (Object.keys(lookUp).length !== 0) {
    const re = new RegExp(Object.keys(lookUp).join('|'), 'gi');
    return slug.replace(re, matched => {
      return lookUp[matched.toLowerCase()];
    });
  }

  return slug;
};

module.exports = replaceSlug;
